import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1)
const _hoisted_3 = { class: "introduce" }
const _hoisted_4 = { class: "introduce-warp" }
const _hoisted_5 = { class: "img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div><div style=\"font-size:22px;font-weight:bold;\">新德科技住宅</div><div style=\"line-height:22px;margin-top:12px;\">苏州工业园区独墅湖启月街紫金东方大厦3-102号</div><div style=\"font-size:14px;\"><div style=\"margin-top:12px;\">开放时间</div><div>09:00-17:00</div><div style=\"margin-top:12px;\">联系电话</div><div>13739175399</div></div></div>", 1)

import {onMounted} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(()=>{
  initMap()
})

function initMap(){
  const targetLat = 120.729615; // 目标位置的纬度
  const targetLng = 31.270671; // 目标位置的经度
  var map = new window.BMapGL.Map("container");
  const point = new window.BMapGL.Point(targetLat,targetLng); // 坐标点的经度和纬度
  map.centerAndZoom(point, 19); // 设置中心点和缩放级别
  const markerPoint = new window.BMapGL.Point(targetLat,targetLng); // 坐标点的经度和纬度
  const marker = new window.BMapGL.Marker(markerPoint);
  map.addOverlay(marker); // 添加标注到地图上
  const infoWindow = new window.BMapGL.InfoWindow("苏州RUUD全空气体验厅欢迎您");
  // const icon = new window.BMapGL.Icon("path-to-icon-image.png", new window.BMapGL.Size(30, 30));
  // const customMarker = new window.BMapGL.Marker(markerPoint, { icon: icon });
  (marker as any).addEventListener("click", function () {
    map.openInfoWindow(infoWindow, markerPoint); // 在标注上打开信息窗口
  });
  (marker as any).addEventListener('click', function() {
    window.location.href = `baidumap://map/navi?location=${targetLat},${targetLng}`;
  });
  const scaleCtrl = new window.BMapGL.ScaleControl();  // 添加比例尺控件
  map.addControl(scaleCtrl);
  const zoomCtrl = new window.BMapGL.ZoomControl();  // 添加缩放控件
  map.addControl(zoomCtrl);

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            width: "94",
            src: require('@/assets/WX20230915-135101@2x.png'),
            alt: ""
          }, null, 8, _hoisted_6)
        ]),
        _hoisted_7
      ])
    ])
  ]))
}
}

})